import React from 'react';
import loadable from '@loadable/component';

import userQuery from './user.graphql';

import { Props as UserProfileProps } from './views/user-profile';

export const UserProfile = loadable(() =>
  import(/* webpackChunkName: "profile" */ './views/user-profile')
);

// Fixes loadable type errors `Property 'graphQL' does not exist on type`

const UserProfilePage = (props: UserProfileProps) => <UserProfile {...props} />;

UserProfilePage.graphQL = userQuery;

type UserProfileVariables = {
  id: string;
  offset: string;
  section: string;
};

UserProfilePage.variables = ({ id, offset, section }: UserProfileVariables) => {
  return {
    id: parseInt(id, 10),
    offset: parseInt(offset, 10) || 0,
    section,
  };
};

export default UserProfilePage;
